jQuery (function () {
    jQuery ('#blog-category-select').on ('change', function () {
        if (jQuery (this).val()) {
            window.location = jQuery (this).val();
        }
    });
});